import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';
import { AnalyzeService } from '../../_services/Analyze/analyze.service';

export const AnalyzeAction = {
    AnalyzeDataAction,
    SingleValidatorAction,
    reloadValidatorAction
}

//OrgAdmin ORG TEAM starts
function AnalyzeDataAction(data,callBack) {
    return dispatch => {
        dispatch(request());
        AnalyzeService.getAnalyzeData(data)
            .then(
                res => {
                    dispatch(success(res));
                    callBack != undefined ? callBack(res) : null
                },
                error => {
                    dispatch(failure(error));
                    callBack != undefined ? callBack(0) : null
                }
            );
    };

    function request() { return { type: AnalyzeConstants.REQUEST_ANALYZE_DATA } }
    function success(res) { return { type: AnalyzeConstants.RECEIVE_ANALYZE_DATA, res } }
    function failure(error) { return { type: AnalyzeConstants.ANALYZE_DATA_ERROR, error } }
}

function SingleValidatorAction() {
    return dispatch => {
        dispatch(success());
        dispatch(request());

    };
    function request() { return { type: AnalyzeConstants.SINGLE_VALIDATOR_FALSE } }
    function success(data) { return { type: AnalyzeConstants.SINGLE_VALIDATOR} }
}

function reloadValidatorAction() {
    return dispatch => {
        dispatch(success());
        dispatch(request());

    };
    function request() { return { type: AnalyzeConstants.RELOAD_FALSE } }
    function success() { return { type: AnalyzeConstants.RELOAD_TRUE} }
}


// WEBPACK FOOTER //
// ./src/_actions/Analyze/analyze.action.js